import axios from "axios";

// Action Types
export const DEVICE_TYPES_LOADING = "DEVICE_TYPES_LOADING";
export const DEVICE_TYPES_SUCCESS = "DEVICE_TYPES_SUCCESS";
export const DEVICE_TYPES_ERROR = "DEVICE_TYPES_ERROR";

export const DEVICE_STATUS_LOADING = "DEVICE_STATUS_LOADING";
export const DEVICE_STATUS_SUCCESS = "DEVICE_STATUS_SUCCESS";
export const DEVICE_STATUS_ERROR = "DEVICE_STATUS_ERROR";

export const DEVICE_ADD_LOADING = "DEVICE_ADD_LOADING";
export const DEVICE_ADD_SUCCESS = "DEVICE_ADD_SUCCESS";
export const DEVICE_ADD_ERROR = "DEVICE_ADD_ERROR";

export const DEVICE_UPDATE_LOADING = "DEVICE_UPDATE_LOADING";
export const DEVICE_UPDATE_SUCCESS = "DEVICE_UPDATE_SUCCESS";
export const DEVICE_UPDATE_ERROR = "DEVICE_UPDATE_ERROR";

export const DEVICE_TRIGGERS_LOADING = "DEVICE_TRIGGERS_LOADING";
export const DEVICE_TRIGGERS_SUCCESS = "DEVICE_TRIGGERS_SUCCESS";
export const DEVICE_TRIGGERS_ERROR = "DEVICE_TRIGGERS_ERROR";

export const UPLOAD_LIST_LOADING = "UPLOAD_LIST_LOADING";
export const UPLOAD_LIST_ERROR = "UPLOAD_LIST_ERROR";
export const UPLOAD_LIST_SUCCESS = "UPLOAD_LIST_SUCCESS";

export const RESET_DEVICE_STATE = "RESET_DEVICE_STATE";
export const RESET_UPLOAD_LIST = "RESET_UPLOAD_LIST";
export const DEVICE_DUPLICATE_ERROR = "DEVICE_DUPLICATE_ERROR";
export const UPLOAD_LIST_ERROR_FILE = "UPLOAD_LIST_ERROR_FILE";

export const DEVICE_TRIGGERS_PBC_LOADING = "DEVICE_TRIGGERS_PBC_LOADING";
export const DEVICE_TRIGGERS_PBC_SUCCESS = "DEVICE_TRIGGERS_PBC_SUCCESS";
export const DEVICE_TRIGGERS_PBC_ERROR = "DEVICE_TRIGGERS_PBC_ERROR";

export const DEVICE_TRIGGERS_PB_LOADING = "DEVICE_TRIGGERS_PB_LOADING";
export const DEVICE_TRIGGERS_PB_SUCCESS = "DEVICE_TRIGGERS_PB_SUCCESS";
export const DEVICE_TRIGGERS_PB_ERROR = "DEVICE_TRIGGERS_PB_ERROR";
// Fetch Device Types
export const fetchDeviceTypes = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_TYPES_LOADING });
  
  try {
    const url = `${process.env.REACT_APP_API_URL}/deviceType/all`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.status === 200) {
      dispatch({
        type: DEVICE_TYPES_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_TYPES_ERROR,
      payload: error.response || "Failed to fetch device types",
    });
  }
};

// Fetch Status Types
export const fetchStatusTypes = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_STATUS_LOADING });
  
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/states/all`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.status === 200) {
      dispatch({
        type: DEVICE_STATUS_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_STATUS_ERROR,
      payload: error.response || "Failed to fetch status types",
    });
  }
};

// Add Device
export const addDevice = (formData) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_ADD_LOADING });
  
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/device/addDevice`;
    const response = await axios({
      method: "POST",
      url: url,
      data: formData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
        validateStatus: (status) => {
        return status === 201 || status === 409;
      },
    });
    
    if (response.status === 201) {
      dispatch({
        type: DEVICE_ADD_SUCCESS,
        payload: response.data,
      });
    } else if (response.status === 409) {
      dispatch({
        type: DEVICE_DUPLICATE_ERROR,
        payload: response.data?.message || "Duplicate device",
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_ADD_ERROR,
      payload: error.response || "Failed to add device",
    });
  }
};

// Update Device
export const updateDevice = (deviceId, formData) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_UPDATE_LOADING });
  
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/device/update/${deviceId}`;
    const response = await axios({
      method: "PUT",
      url: url,
      data: formData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
       validateStatus: (status) => {
        return status === 200 || status === 409;
      },
    });
    
    if (response.status === 200) {
      dispatch({
        type: DEVICE_UPDATE_SUCCESS,
        payload: response.data,
      });
    } else if (response.status === 409) {
      dispatch({
        type: DEVICE_DUPLICATE_ERROR,
        payload: response.data?.message || "Duplicate device",
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_UPDATE_ERROR,
      payload: error.response || "Failed to update device",
    });
  }
};

// Fetch Trigger Options (devices of type 4)
export const fetchTriggerOptions = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_TRIGGERS_LOADING });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/device/type/103`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.status === 200) {
      dispatch({
        type: DEVICE_TRIGGERS_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_TRIGGERS_ERROR,
      payload: error.response || "Failed to fetch trigger options",
    });
  }
};
export const fetchTriggerOptionsPBC = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_TRIGGERS_PBC_LOADING });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/device/type/5`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.status === 200) {
      dispatch({
        type: DEVICE_TRIGGERS_PBC_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_TRIGGERS_PBC_ERROR,
      payload: error.response || "Failed to fetch trigger options",
    });
  }
};

export const fetchTriggerOptionsPB = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: DEVICE_TRIGGERS_PB_LOADING });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/device/type/4`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.status === 200) {
      dispatch({
        type: DEVICE_TRIGGERS_PB_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEVICE_TRIGGERS_PB_ERROR,
      payload: error.response || "Failed to fetch trigger options",
    });
  }
};

// Reset Device State
export const resetDeviceState = () => ({
  type: RESET_DEVICE_STATE
});
 
export const uploadActions = (file) => async (dispatch) => {
  dispatch({ type: UPLOAD_LIST_LOADING });

  const token = JSON.parse(localStorage.getItem("token"));

  try {
    if (!file) throw new Error("No file selected");

    const formData = new FormData();
    formData.append("file", file);

    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/devices/bulk-upload`;

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    const { errors = [], successCount } = response.data;

    if (errors.length > 0) {
      dispatch({
        type: UPLOAD_LIST_ERROR_FILE,
        payload: errors,
      });
    } else {
      dispatch({
        type: UPLOAD_LIST_SUCCESS,
        payload: { successCount },
      });
    }
  } catch (error) {
    dispatch({
      type: UPLOAD_LIST_ERROR,
      payload: error.response?.data?.message || error.message,
    });
  }
};
